import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as DatasetActions from './google-sheet.actions';

export const GOOGLE_SHEET_DATASET_FEATURE_KEY = 'googleSheetDataset';

export interface GoogleSheetIngestEntityState {
  progressToastId?: number | null;
  reportRunToken: string;
  loaded: boolean; // has the ReportClone list been loaded
  error?: string | null; // last known error (if any)
}

export interface GoogleSheetIngestState {
  googleSheetIngestEntities: EntityState<GoogleSheetIngestEntityState>;
}

export const googleSheetIngestAdapter: EntityAdapter<GoogleSheetIngestEntityState> =
  createEntityAdapter<GoogleSheetIngestEntityState>({
    selectId: (state) => state.reportRunToken,
  });

export const initialGoogleSheetIngestState: GoogleSheetIngestState = {
  googleSheetIngestEntities: googleSheetIngestAdapter.getInitialState(),
};

const googleSheetIngestEntitiesReducer = createReducer(
  initialGoogleSheetIngestState.googleSheetIngestEntities,
  on(DatasetActions.ingestGoogleSheetInProgresss, (state, action) =>
    googleSheetIngestAdapter.upsertOne(
      { loaded: false, progressToastId: action.progressToastId, reportRunToken: action.token },
      state
    )
  ),
  on(DatasetActions.ingestGoogleSheetSuccess, (state, action) =>
    googleSheetIngestAdapter.upsertOne({ loaded: true, reportRunToken: action.token }, state)
  ),
  on(DatasetActions.ingestGoogleSheetFailed, (state, action) =>
    googleSheetIngestAdapter.upsertOne({ loaded: true, reportRunToken: action.token }, state)
  )
);

export const googleSheetIngestReducer: ActionReducerMap<GoogleSheetIngestState> = {
  googleSheetIngestEntities: googleSheetIngestEntitiesReducer,
};

export const { selectEntities } = googleSheetIngestAdapter.getSelectors();
